export enum MaskedFieldType {

    Email = 0,
    Phone = 1
}
